module.exports = __webpack_public_path__ + "img/before6.49a9a8b2.png";